module.exports = __webpack_public_path__ + "static/media/impactbyte.cbd0a429.png";